export const buildShortString = (string_: string) => {
  const strippedName = string_
    .toLowerCase()
    .replace(" ", "")
  return `${strippedName
    .charAt(0)
    .toUpperCase()}${strippedName.charAt(1)}`
}
